export enum DayType {
    Guideline = 'Guideline',
    Deadline = 'Deadline',
}

export enum  PlanPriorities {
    Normal = 'Normal',
    Low = 'Low',
    Critical = 'Critical',
}

export enum PlanTypes {
    LeadPlanHeader = 'LeadPlanHeader',
    Action = 'Action',
    UserPlanHeader = 'UserPlanHeader',
    BrokenUserPlanHeader = 'BrokenUserPlanHeader',
    HugPlan = 'HugPlan',
    HugPlanTemplate = 'HugPlanTemplate',
}

export enum ActionPlanStatus {
    Active = 'Active',
    Completed = 'Completed',
    Running = 'Running',
    EventPaused = 'EventPaused',
    EventResumed = 'EventResumed',
    NoEngageUser = 'NoEngageUser',
    Paused = 'Paused',
    NotScheduled = 'NotScheduled',
    AttemptFirst = 'AttemptFirst',
    AttemptSecond = 'AttemptSecond',
    AttemptThird = 'AttemptThird',
    Deleted = 'Deleted',
    FailedNoConsent = 'FailedNoConsent',
    Failed = 'Failed',
}

export enum ActionPlanAssignedUserType {
    Primary = 'Primary',
    Manual = 'Manual',
}

export enum ActionPlanRelatedType {
    listing = 'listing',
    sendGrid = 'sendGrid',
}

export enum ActionPlanCategories {
    Default = 0,
    Archived = 1,
    Coaching = 2,
    Platinum = 4
}

export enum ActionTypes {
    Task = 'Task',
    SMS = 'SMS',
    Email = 'Email',
    Voicemail = 'Voicemail',
    Picture = 'Picture',
    Video = 'Video',
    DisplayEvent = 'DisplayEvent',
}
